import * as React from 'react';
import { observer } from 'mobx-react';
import { Page, Pane, PaneBody, PaneHeader } from '../../components/atoms/applications/page';
import './subscriptionSuspensionInfoPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { SubscriptionSuspensionCancelInfoPageState } from './states/SubscriptionSuspensionCancelInfoPageState';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { V3Routes } from '../../routes';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { LabelPrimary } from '../../components/atoms/labels/LabelPrimary';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import moment from 'moment-timezone';
import { BackButtonHeader } from '../../components/organisms/mypage/BackButtonHeader';
import { DetailedDateRange } from '../../../admin/components/date/TimeRange';
import { OverlayPage } from '../../../commonv3/components/molecules/layout/OverlayPage';
import { SubscriptionSuspensionCancelCompletePane } from '../../components/molecules/subscription_suspensions/SubscriptionSuspensionCancelCompletePane';

type Props = {
    match: {
        params: {
            subscriptionCode: string;
        };
    };
};

@withNavigation(NavigationSpecs.home('white', true), NavigationSpecs.none())
@observer
export class SubscriptionSuspensionCancelInfoPage extends React.Component<Props> {
    pageState = new SubscriptionSuspensionCancelInfoPageState();

    componentDidMount() {
        const { subscriptionCode } = this.props.match.params;
        this.pageState.init(subscriptionCode);
    }

    render() {
        const currentUser = GlobalStatesV3.currentUser;
        const { subscription: subscriptionResource, open } = this.pageState;
        if (!this.pageState.initialized) {
            return <LoaderRow />;
        }
        if (subscriptionResource.isNotFound()) {
            return <NotFoundPage entityType="Subscription" />;
        }
        if (subscriptionResource.isError()) {
            GlobalStatesV3.routing.push(V3Routes.home());
            return null;
        }
        const subscription = subscriptionResource.get();
        return (
            <Page>
                <Pane styleName="pane">
                    {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.plan()} />}
                    <PaneHeader>休会からの復帰について</PaneHeader>
                    <PaneBody>
                        <div styleName="schedule_box_inner">
                            <div styleName="schedule_text">{currentUser.currentUser.name}さんの休会期間</div>

                            <div styleName="schedule_date">
                                {subscription.subscription_suspension && (
                                    <DetailedDateRange
                                        fromDate={subscription.subscription_suspension.starts_at}
                                        toDate={subscription.subscription_suspension.ends_at}
                                    />
                                )}
                            </div>
                        </div>

                        <div styleName="attention">
                            <div>
                                <LabelPrimary label="復帰の手順について" />
                                <div styleName="text">
                                    ・休会期間が終わると自動的に復帰となり、課金が再開されます。<br />
                                    ・休会期間中に復帰したい場合は下記の復帰するボタンから復帰することができます。
                                </div>

                                <LabelPrimary label="休会条件" />
                                <div styleName="text red">
                                    休会期間中に復帰する場合、復帰ボタンを押した日が新たな課金更新日として設定され、お支払いサイクルが変更されます。
                                </div>
                            </div>
                        </div>

                        <div styleName="info">
                            <div styleName="schedule_text">本日復帰する場合の新たな課金更新日</div>
                            <div styleName="schedule_date">
                                毎月<span styleName="date">{moment().format('D')}</span>日
                            </div>
                            <div styleName="info-text">
                                {moment().format('YYYY/MM/DD')}〜
                                {moment()
                                    .add(1, 'M')
                                    .format('YYYY/MM/DD')}
                                分の受講料に対する課金が本日発生いたします。
                            </div>
                        </div>

                        <div styleName="attention">
                            <div styleName="submit_button">
                                <Button
                                    type="primary"
                                    size="l"
                                    onClick={() => this.pageState.submit()}
                                    loading={this.pageState.submitState.submitting}
                                >
                                    復帰する
                                </Button>
                            </div>
                        </div>

                        <OverlayPage open={open} onRequestClose={() => {}}>
                            <SubscriptionSuspensionCancelCompletePane
                                renewalDate={subscription.renewal_date}
                                durationMonth={subscription.duration_month}
                                onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.home())}
                            />
                        </OverlayPage>
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
